import { render, staticRenderFns } from "./downItem.vue?vue&type=template&id=5b5594bf&scoped=true&"
import script from "./downItem.vue?vue&type=script&lang=js&"
export * from "./downItem.vue?vue&type=script&lang=js&"
import style0 from "./downItem.vue?vue&type=style&index=0&id=5b5594bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5594bf",
  null
  
)

export default component.exports